import { createContext, useContext, useState, useCallback, ReactNode } from 'react'

interface OverrideRefreshContextType {
  refreshTrigger: number
  triggerOverrideRefresh: () => void
  refreshOverrideForAircraft: (aircraftId: number) => void
  lastRefreshedAircraft: number | null
  // Options refresh
  optionsRefreshTrigger: number
  triggerOptionsRefresh: (aircraftId: number) => void
  lastRefreshedOptionsAircraft: number | null
}

const OverrideRefreshContext = createContext<OverrideRefreshContextType | undefined>(undefined)

export function OverrideRefreshProvider({ children }: { children: ReactNode }) {
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const [lastRefreshedAircraft, setLastRefreshedAircraft] = useState<number | null>(null)
  const [optionsRefreshTrigger, setOptionsRefreshTrigger] = useState(0)
  const [lastRefreshedOptionsAircraft, setLastRefreshedOptionsAircraft] = useState<number | null>(null)

  const triggerOverrideRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1)
    setLastRefreshedAircraft(null)
  }, [])

  const refreshOverrideForAircraft = useCallback((aircraftId: number) => {
    setRefreshTrigger(prev => prev + 1)
    setLastRefreshedAircraft(aircraftId)
  }, [])

  const triggerOptionsRefresh = useCallback((aircraftId: number) => {
    setOptionsRefreshTrigger(prev => prev + 1)
    setLastRefreshedOptionsAircraft(aircraftId)
  }, [])

  return (
    <OverrideRefreshContext.Provider value={{
      refreshTrigger,
      triggerOverrideRefresh,
      refreshOverrideForAircraft,
      lastRefreshedAircraft,
      optionsRefreshTrigger,
      triggerOptionsRefresh,
      lastRefreshedOptionsAircraft
    }}>
      {children}
    </OverrideRefreshContext.Provider>
  )
}

export function useOverrideRefresh() {
  const context = useContext(OverrideRefreshContext)
  if (context === undefined) {
    throw new Error('useOverrideRefresh must be used within an OverrideRefreshProvider')
  }
  return context
}
